import { Avatar, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import awards from './awards';
import OverviewContent from './OverviewContent';
import BasePaper from './BasePaper';
import SubHeading from './SubHeading';
import { useTheme } from '@emotion/react';

const title = [
  {
    name: 'Purpose',
    description: [
      'At Gateway Group,',
      `Our Rewards and Recognition (RnR) is a cornerstone of the organisation's commitment to creating a workplace culture that values, motivates, and engages the team members.`,
      `The primary purpose of this is to inspire the workforce by acknowledging and celebrating their exceptional contributions, regardless of the scale or frequency of their achievements which, fosters a culture that recognizes excellence, promotes personal and professional growth, and aligns with our company's strategic objectives and foundational values.`,
    ],
    type: 'li',
    highlight: true,
  },
  {
    name: 'Scope',
    description: [
      'The applicability',
      'of this program is for team members working in Gateway Group of Companies',
      `The purpose is to recognize, appreciate and motivate team members, creating an environment where individuals are driven to attain both personal and team accomplishments aligned with the overall growth and objectives of the organisation.`,
    ],
    type: 'p',
    highlight: true,
  },
];
const RnrOverview = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        // width:'50vw'
        background: 'white',
        border: 0.5,
        borderRadius: '8px',
        borderColor: 'divider',
      }}
    >
      {/* Purpose & Scope containers */}
      <Stack sx={{ m: '0 auto', width: '100%' }}>
        {title.map((item, ind) => {
          return ind < 2 && <OverviewContent key={item.name} item={item} ind={ind} type='p' />;
        })}
      </Stack>

      {/* Categories */}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 1,
          mb: 4,
        }}
      >
        <SubHeading heading='Categories' />

        <Box
          sx={{
            display: 'grid',
            width: '100%',
            gridTemplateColumns: 'repeat(3,1fr)',
            p: 1,
            [theme.breakpoints.down('lg')]: {
              gridTemplateColumns: 'repeat(2,1fr)',
            },
          }}
        >
          {awards.map((award, ind) => {
            return (
              <Box
                className='awardCard'
                key={ind}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRight: (ind + 1) % 3 == 0 ? 'none' : 1,
                  borderColor: 'divider',
                  flexDirection: 'column',
                  m: 2,
                  position: 'relative',
                  [theme.breakpoints.down('lg')]: {
                    mr: 1,
                    border: 0,
                  },
                }}
              >
                <Box
                  className='description'
                  sx={{
                    [theme.breakpoints.down('lg')]: {
                      display: 'none',
                    },
                  }}
                >
                  {award.description}
                </Box>
                <Avatar
                  src={award.img}
                  variant='rounded'
                  sx={{
                    width: '130px',
                    height: '130px',
                    [theme.breakpoints.down('lg')]: {
                      width: '100px',
                      height: '100px',
                    },
                  }}
                />
                <Typography variant='caption' sx={{ fontWeight: 'bold', mt: 2 }}>
                  {award.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Nomination parameters */}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 1,
        }}
      >
        <Box sx={{ width: 'max-content', p: 1, mb: 2, mt: 2, textAlign: 'center' }}>
          <Typography
            component='span'
            fontWeight={'bold'}
            sx={{ fontSize: { md: '1.5rem', lg: '1.75rem', lineHeight: 0.5 } }}
          >
            <Typography
              component='div'
              fontWeight={'bold'}
              sx={{ color: '#0a4fac', fontSize: { md: '1.5rem', lg: '1.75rem' } }}
            >
              Nomination &
            </Typography>
            Evaluation parameters
          </Typography>
        </Box>
        <Box
          component={BasePaper}
          elevation={3}
          sx={{
            backgroundColor: 'rgba(0,0,0,0.03)',
            width: '100%',
            p: 1,
            pt: 0,
            textAlign: 'justify',
            listStyle: 'square',
            li: {
              fontSize: { md: '0.85rem', lg: '14px' },
            },
            '& li::marker': {
              color: '#0a4fac',
              fontSize: '1.75em',
            },
          }}
        >
          <Typography component='li'>All applicable parameters must be duly filled for each nomination.</Typography>

          <Typography component='li'>
            Nominations must be submitted without bias and along with required attachments.
          </Typography>

          <Typography component='li'>An Individual must be nominated for only for 1 category per quarter.</Typography>

          <Typography component='li'>
            Evaluation for nominations shall be addressed and completed duly by Panel committee.
          </Typography>

          <Typography component='li'>
            HR shall request for Nominations every quarter. R&R Award Ceremony shall be arranged Quarterly.
          </Typography>
          <Typography component='li'>
            Reward Evaluation Panel consists of CTO/ Delivery Heads/Heads of the respective domains/ departments.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RnrOverview;
